import { Env, Hosts } from './env.type';

export const defaultHosts: Hosts = {
  vsAdminApp: 'https://admin.dev.cloud.viewsonic.com',
  vsApp: 'https://dev.cloud.viewsonic.com',
  vsApi: 'https://api.dev.cloud.viewsonic.com',
  vsSsoApi: 'https://api.dev.viewsonic.cloud',
  vsAsset: 'https://assets.dev.cloud.viewsonic.com',
};

export const env: (opts: { hosts: Hosts }) => Env = ({ hosts }) => ({
  deployEnv: 'dev',
  apiEndpoint: {
    mvb: 'https://api.dev.myviewboard.com',
    vs: hosts.vsApi,
    dmAdmin: 'https://dm.dev.myviewboard.cloud/api/dm/admin',
    vsSubscription: `${hosts.vsApi}/subscription/graphql/v1/subscription`,
    vsAuth: hosts.vsApp,
    vsSso: hosts.vsSsoApi,
    vsAdminAuth: hosts.vsAdminApp,
  },
  oidcAuthority: {
    vs: `${hosts.vsApp}/auth/v1/oidc`,
    vsAdmin: `${hosts.vsAdminApp}/auth/v1/oidc`,
  },
  appUrl: {
    legalDoc: `${hosts.vsApp}/legal`,
    accountPortal: `${hosts.vsApp}/account`,
    entityPortal: `${hosts.vsApp}/entity`,
  },
  applicationInsightsInstrumentationKey: {
    mvb: '46197682-3035-49e9-af33-bdd80df26aa3',
  },
  assets: {
    vs: `${hosts.vsAsset}`,
  },
  product: {
    mvb: 'https://dev.myviewboard.com/preview',
    dm: 'https://dev.myviewboard.com/mydashboard/dm',
    classSwift: 'https://www.classswift.viewsonic.io/',
    teamone: 'https://dev.teamone.viewsonic.com/dashboard',
    originals: 'https://dev.myviewboard.com/originals',
  },
  downloads: {
    nfcConnectorInstaller:
      'https://store2.myviewboard.com/uploads/launcher-nfc/NFC-ConnectorInstaller_1.0.4.exe',
  },
});
